module.exports = __webpack_public_path__ + "static/img/bg6.e5405fec.webp";